import { Avatar, Box, Button, Card, Divider, Typography } from "@mui/material";
import React from "react";
import { UserButton, useAuth } from "@clerk/clerk-react";
import { useNavigate } from "react-router-dom";

const DotIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fill="currentColor"
      width="10"
      height="10"
    >
      <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z" />
    </svg>
  );
};

const Header = ({ children }) => {
  const navigate = useNavigate();
  const { isSignedIn } = useAuth();

  const handleLoginNavigation = () => {
    navigate("/signIn");
  };

  const navigateHome = () => {
    navigate("/");
  };

  return (
    <>
      <Card
        sx={{
          display: "flex",
          p: 2,
          px: 4,
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: "rgba(0, 0, 0, 0.15) 0px 4px 12px",
          borderRadius: 2,
          backgroundColor: "white",
        }}
      >
        {/* Left Section - Logo and Title */}
        <Box
          onClick={navigateHome}
          sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        >
          <Avatar
            src="./assets/logo.png"
            alt="Logo"
            sx={{
              backgroundColor: "primary.main",
              height: 32,
              width: 32,
              mr: 1,
            }}
          />
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", color: "text.primary" }}
          >
            Fika
          </Typography>
        </Box>

        {/* Right Section - User Button or Login */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {isSignedIn ? (
            <>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => navigate("/dashboard")}
                sx={{
                  mr: 2,
                  fontWeight: "bold",
                  textTransform: "none",
                  color: "primary.main",
                  borderColor: "primary.main",
                  "&:hover": {
                    borderColor: "primary.dark",
                    backgroundColor: "primary.light",
                  },
                }}
                startIcon={<DotIcon />}
              >
                Dashboard
              </Button>
              <UserButton />
            </>
          ) : (
            <Button
              onClick={handleLoginNavigation}
              variant="contained"
              size="large"
              color="primary"
              sx={{
                fontWeight: "bold",
                textTransform: "none",
              }}
            >
              Sign In
            </Button>
          )}
        </Box>
      </Card>
      <Divider />

      {children}
    </>
  );
};

export default Header;
